__turbopack_context__.v({
  "Chart": "revenue-distribution-chart-module__TREIvW__Chart",
  "LegendItem": "revenue-distribution-chart-module__TREIvW__LegendItem",
  "Legends": "revenue-distribution-chart-module__TREIvW__Legends",
  "Marker": "revenue-distribution-chart-module__TREIvW__Marker",
});
